import { styled as muiStyled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const tabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content',
  paddingLeft: '2.4rem',
  '& .MuiTabs-flexContainer': {
    width: 'fit-content',
    gap: '2.4rem',
  },
  '& .MuiTab-root': {
    width: 'fit-content',
    padding: '1.6rem 2.2rem',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    fontWeight: 400,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    color: `${abyssColors.primary[400]} !important`,
    flexGrow: 0,
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 500,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    borderRadius: '0.8rem',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: `0.1rem solid ${abyssColors.primary[200]}`,
  width: '100%',
  position: 'relative',
  bottom: '0.3rem',
  zIndex: '1',
  opacity: 0.5,
}));
